import { styled } from "@mui/material";
import { TextField } from "../../../../components/TextField/index.js";
const FormUITextField = styled(TextField, {
  name: "FormUITextField"
})({
  // The margin top has been added to prevent the label to going outside of the component area
  marginTop: 5
});
export {
  FormUITextField
};
//# sourceMappingURL=FormUITextField.js.map
